export function P1(props) {
  return <p className="pd-paragraph-p1">{props.children}</p>;
}

export default P1;
